Dates = require 'app/scripts/lib/dates'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
moment = require 'moment'
template = require 'app/scripts/views/templates/header_warning_account_transfer_required'

module.exports = class AccountTransferRequiredBannerView extends View
  className: 'header-banner'

  constructor: ({ enterprise }) ->
    super
    @enterprise = enterprise

  events:
    'click .js-dismiss-account-transfer': 'dismiss'

  dismiss: (e) ->
    Util.stop(e)
    @model.dismissAccountTransferBanner =>
      @remove()

  _remainingDays: ->
    targetDate = Dates.parse(@enterprise.get('prefs').mandatoryTransferDate)
    Dates.getDaysUntil(targetDate)

  renderRemainingDays: ->
    remainingDays = @_remainingDays()
    if remainingDays <= 10
      @$el.addClass('mod-warning')
    else
      @$el.addClass('mod-info')

    if 1 < remainingDays <= 5
      @$el.addClass('mod-medium-urgent')
    else if remainingDays <= 1
      @$el.addClass('mod-urgent')

    @$el.html(
      template(
        targetDate: Dates.toDateString(@enterprise.get('prefs').mandatoryTransferDate),
        enterpriseDisplayName: @enterprise.get('displayName')
      )
    )

  render: ->
    if !@model.isAccountTransferBannerDismissed() && @enterprise?
      @renderRemainingDays()
    @
